module.exports = __webpack_public_path__ + "static/media/22ESCWA2.ff93ad92.jpg";